import { Helmet } from "react-helmet-async";

const SITE = "https://saverpluslighting.com";

// Per-page SEO: unique title, description, canonical + OG text.
// NOTE: og:image / twitter:card live in index.html (static) so non-JS social
// crawlers (FB, LinkedIn, WhatsApp, Slack) can read them — they never run JS.
export default function Seo({ title, description, path = "/", index = true, jsonLd = null }) {
  const url = `${SITE}${path}`;
  const fullTitle = title;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={index ? "index, follow, max-image-preview:large" : "noindex, nofollow"} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Saver Plus Lighting Corp." />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
